import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6">
      <div className="max-w-md text-center">
        <div className="mb-4 text-6xl">🧭</div>
        <h1 className="mb-2 text-2xl font-bold text-gray-800">Page Not Found</h1>
        <p className="mb-6 text-gray-600">
          The page you're looking for doesn't exist or is no longer available.
        </p>
        <Link
          to=""
          className="inline-block rounded-lg bg-green-700 px-4 py-2 font-medium text-white transition-colors hover:bg-green-800"
        >
          Back to Overview
        </Link>
      </div>
    </div>
  );
}
